module.exports = __webpack_public_path__ + "static/media/you-got-money-icon.98aaa293.png";